<template>
    <div class="col-12">
      <div class="row flex-column">
        <q-expansion-item
          default-opened
          expand-icon-toggle
          header-class="align-items-center bg-secondary justify-content-between mb-3 mt-3 "
        >
          <template v-slot:header>
            <q-item-section>
              {{ capitalize($t("summaryPanel.financing.guarantee.label").toLowerCase()) }}
            </q-item-section>
          </template>
          <div class="row" v-for="(guarantee, index) in proposalGuarantees" :key="index">
            <div class="col-4 mb-2">
              <LabelAndValue
                :i18n-key="'guarantees.labels.guaranteeType'"
                :value="guarantee.productGuarantee?.guaranteeType"
                :oneLine="true"
                :label-style="labelStyleItem"
                :div-value-style="divValueStyle"
              />
            </div>
            <div class="col-4 mb-2" >
              <LabelAndValue
                :i18n-key="'guarantees.labels.label'"
                :value="guarantee.productGuarantee?.name"
                :oneLine="true"
                :label-style="labelStyleItem"
                :div-value-style="divValueStyle"
              />
            </div>
            <div class="col-4 mb-2" v-if="guarantee.associatedParty?.third.person || guarantee.associatedParty?.third.organization" >
              <LabelAndValue v-if="guarantee.associatedParty?.third.person"
                :i18n-key="'guarantees.labels.guarantor'"
                :value="guarantee.associatedParty?.third.person.firstName+' '+guarantee.associatedParty?.third.person.familyName"
                :oneLine="true"
                :label-style="labelStyleItem"
                :div-value-style="divValueStyle"
              />
              <LabelAndValue v-else
                :i18n-key="'guarantees.labels.guarantor'"
                :value="guarantee.associatedParty?.third.organization.name"
                :oneLine="true"
                :label-style="labelStyleItem"
                :div-value-style="divValueStyle"
              />
              
            </div>
            <div class="col-4 mb-2" v-else >
                <LabelAndValue 
                  :i18n-key="'guarantees.labels.guarantor'"
                  :value="'-'"
                  :oneLine="true"
                  :label-style="labelStyleItem"
                  :div-value-style="divValueStyle"
                  />
            </div>
            <div class="col-4 mb-2" >
              <LabelAndValue
                :i18n-key="'guarantees.labels.value'"
                :value="guarantee.amount?.amount ?? 0"
                :oneLine="true"
                :label-style="labelStyleItem"
                :div-value-style="divValueStyle"
              />
            </div>
          </div>
        </q-expansion-item>
      </div>
    </div>

  </template>
  
  <script lang="ts">
  import { Options, Vue } from "vue-class-component";
  import LabelAndValue from "@/components/general/LabelAndValue.vue";
  import { globalConfig } from "@/utils";
  import { formatWithMask } from "@/utils/configuration/formatters-config";
  import store from "@/store";
  
  @Options({
    components: { LabelAndValue },
    props: ["proposal", "valueStyle", "labelStyle", "divValueStyle"],
  })
  export default class SummaryFinancingGuarantee extends Vue {
  
    proposalPartyInsuranceObjectType = 'odm.offer.proposalaccessories.proposalinsurance.proposalpartyinsurance'
    capitalize = globalConfig.capitalize;
    proposal?: any;
    labelStyle?: any;
  
    baseServiceKey = "demand.product.services.names";

    get proposalGuarantees() {
      return this.proposal.proposalGuarantees || []
    }
  
    get guaranteeList() {
      return this.proposalGuarantees.map((guarantee: any) => {
        return {
          label: `${this.baseServiceKey}.${guarantee.resourceUid.replaceAll(
            ".",
            "_"
          )}`,
          value: `${formatWithMask(
            guarantee.amount,
            2
          )} ${globalConfig.currencyMapper('EUR')}`,
        };
      });
    }
    valueStyle = {
      "font-weight": "bold",
      "margin-left": "20px",
      color: "black",
    };
  
    divValueStyle = {
      display: "flex",
      "justify-content": "end",
      "padding-right": "10px",
    };
    labelStyleItem = {
      "font-size": "1rem",
      color: "gray",
      "font-weight": "bold",
    };
  }
  </script>
  
  <style lang="scss" scoped></style>
  